import { render, staticRenderFns } from "./face_geo.vue?vue&type=template&id=0f65aad4&lang=pug&"
import script from "./face_geo.vue?vue&type=script&lang=js&"
export * from "./face_geo.vue?vue&type=script&lang=js&"
import style0 from "./face_geo.vue?vue&type=style&index=0&id=0f65aad4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports